(function () {
  'use strict';

  function initSahlaarTrust(root) {
    if (!root || root.dataset.sahlaarInit === 'true') return;
    root.dataset.sahlaarInit = 'true';

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Scroll reveal */
    var revealEls = root.querySelectorAll('[data-sahlaar-reveal]');
    if ('IntersectionObserver' in window && revealEls.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var delay = entry.target.getAttribute('data-sahlaar-delay');
              if (delay) {
                entry.target.style.transitionDelay = delay + 'ms';
              }
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
      );
      revealEls.forEach(function (el) {
        observer.observe(el);
      });
    } else {
      revealEls.forEach(function (el) {
        el.classList.add('is-visible');
      });
    }

    /* Mouse-based 3D tilt on bottle (GPU-accelerated transform only) */
    var stage = root.querySelector('[data-sahlaar-stage]');
    var bottle = root.querySelector('[data-sahlaar-bottle]');

    if (stage && bottle && !reducedMotion && window.matchMedia('(pointer: fine)').matches) {
      var rafId = null;
      var targetX = 0;
      var targetY = 0;

      stage.addEventListener('mousemove', function (e) {
        var rect = stage.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        targetX = y * -4;
        targetY = x * 6;

        if (rafId === null) {
          rafId = window.requestAnimationFrame(function () {
            bottle.style.transform =
              'rotateX(' + targetX + 'deg) rotateY(' + targetY + 'deg)';
            rafId = null;
          });
        }
      });

      stage.addEventListener('mouseleave', function () {
        window.requestAnimationFrame(function () {
          bottle.style.transform = 'rotateX(0deg) rotateY(0deg)';
        });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.sahlaar-trust').forEach(initSahlaarTrust);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme editor support: re-init on section load/reorder */
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.sahlaar-trust');
    if (section) {
      section.dataset.sahlaarInit = 'false';
      initSahlaarTrust(section);
    }
  });
})();